var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"rating-avatar ajax__line",staticStyle:{"border-radius":"50%"}})}
var staticRenderFns = []

export { render, staticRenderFns }